import { createHumps } from 'lodash-humps-ts';
import { snakeCase } from 'lodash';

export const snakes: (node: object) => Record<string, string> = createHumps(snakeCase);
